import axios from '../../axios'

/**
 * 驾校 开启/关闭 理论培训
 * @param {*} data 
 * id	是	string	驾校Id
isOpenTheory	是	string	是否开启理论 0：关闭 1：开启
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=19171762
 */
export const enableTheoreticalTraining = data => {
  return axios({
    url: '/school/isOpenTheory',
    method: 'post', data
  })
}

  /**
 * @驾校t同步
 * @param {*} data 
 * @Id	否	String	驾校id
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=19172216
 */
  export const schoolSync = params => {
    return axios({
        url: `/school/sync/${params.id}`,
        // method: 'post',
        // params
    })
  }

/**
 * 保存 关联驾校和车型提供商
 * @param {*} data 
    courseType	是	string	配置车型 A1、A2
    business	是	string	承运商
    name	否	string	过滤条件
    ids	是	List	选中的学校id 集合
 * @wiki   http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12060010  20220616
 */
export const saveServiceProviderWithSchool = data => {
  return axios({
    url: '/schoolcrousesource/updateTree',
    method: 'post',
    data
  })
}
/**
 * 查询 全部 驾校树
 * @param {*} data 
 * courseType	是	string	配置车型 A1、A2
    business	是	string	承运商
    name	是	string	驾校名称
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12060007  20220616 
 */
export const treeSchoolAll = data => {
  return axios({
    url: '/school/editTree',
    method: 'post',
    data
  })
}
/**
 * 查询 驾校树
 * @param {*} data 
    courseType	是	string	配置车型 A1、A2
    business	是	string	承运商
    name	否	string	学校名称
 * @wiki   http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12060003  20220615
 */
export const treeSchool = data => {
  return axios({
    url: '/school/listHasTree',
    method: 'post',
    data
  })
}
/**
 * 根据 区域id 查询 驾校
 * @param {*} data 
 * district	是	string	区划
 * @returns 
 */
export const listByDistrictId = data => {
  return axios({
    url: '/school/optionSchoolList',
    method: 'post',
    data
  })
}
/**
 * 根据部门id查询 培训机构列表
 * @param {*} data 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059430 20220425 
 */
export const listByDeptId = data => {
  return axios({
    url: '/sysmanagerdept/optionManagerDept',
    method: 'post',
    data
  })
}
/**
 * 查询待绑定驾校列表
 * @param {*} data 
 * district	否	string	区划
    name	否	string	驾校名称
    accountDeptId	是	string	当前登录账号deptId
 * @wiki  http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=12059417  20220422
 */
export const listForBind = data => {
  return axios({
    url: '/school/deptBindSchoolList',
    method: 'post',
    data
  })
}
/**
 * 查询 未发放 卡片列表
 * @param schoolId * 驾校id
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=703060
 */
export const getUnIssueCardList = data => {
  return axios({
    url: '/stucard/findCard',
    method: 'post',
    data
  })
}
/*
 * 用户管理模块
 */

/**
 * 导出 
 * @param name  驾校名称
 * @param shortName 驾校简称
 * @param inscode 驾校编号
 * @param state 状态
 * @param level 等级
 * @param busistatus 经营状况
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=702482
 */
export const exportSchool = data => {
  return axios({
    url: '/school/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 保存
export const save = (data) => {
  return axios({
    url: '/school/save',
    method: 'post',
    data
  })
}
// 删除
export const deleteOne = (data) => {
  return axios({
    url: '/school/delete',
    method: 'post',
    data
  })
}
// 分页查询
export const findPage = (data) => {
  return axios({
    url: '/school/list',
    method: 'post',
    data
  })
}
// 分页查询
export const detailView = (data) => {
  return axios({
    url: '/school/detail',
    method: 'post',
    data
  })
}
export const schoolAll = (data => {
  return axios({
    url: '/school/listAll',
    method: 'post',
    data
  })

})

export const importSchool = (data => {
  return axios({
    url: '/school/importSchool',
    method: 'post',
    data
  })
})


export const auditSchool = (data) => {
  return axios({
    url: '/school/report/'+data,
    method: 'post'
  })
}
export const saveSign = (data => {
  return axios({
    url: '/schoolSign/saveSign',
    method: 'post',
    data
  })
})
export const querySchoolSign = (data => {
  return axios({
    url: '/schoolSign/querySchoolSign',
    method: 'post',
    data
  })
})



// WEBPACK FOOTER //
// ./src/http/modules/school/school.js